import React from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SectionHeader, Loading, EmptyState, Tag } from "@/components/brand";
import { formatR } from "@/lib/format";
import dayjs from "dayjs";

const STATUSES = ["paid", "shipped", "delivered", "cancelled"];

export default function AdminOrders() {
  const qc = useQueryClient();
  const orders = useQuery({ queryKey: ["admin", "orders"], queryFn: () => api("/admin/orders") });
  const update = useMutation({ mutationFn: ({ id, status }) => api(`/admin/orders/${id}/status`, { method: "POST", body: { status } }), onSuccess: () => { qc.invalidateQueries({ queryKey: ["admin", "orders"] }); toast.success("Order updated"); }, onError: (e) => toast.error(e.message) });
  const tone = (s) => s === "delivered" ? "green" : s === "cancelled" ? "grey" : s === "pending_payment" ? "dark" : "pink";

  return (
    <div data-testid="admin-orders-screen" className="space-y-5">
      <SectionHeader title="Orders" subtitle="Fulfil shop orders." />
      {orders.isLoading ? <Loading /> : (orders.data ?? []).length === 0 ? <EmptyState title="No orders" /> : (
        <div className="space-y-2">
          {orders.data.map((o) => (
            <div key={o.id} data-testid={`admin-order-${o.id}`} className="p-4 rounded-xl2 border border-divider">
              <div className="flex items-center justify-between gap-2">
                <div><div className="font-display text-base text-ink">{o.title}</div><div className="font-body text-xs text-mutedgrey">{o.user_name} · {dayjs(o.created_at).format("D MMM, HH:mm")} · {o.address?.city}</div></div>
                <div className="flex items-center gap-2"><span className="font-display text-brand">{formatR(o.total)}</span><Tag label={o.status === "pending_payment" ? "pending" : o.status} tone={tone(o.status)} /></div>
              </div>
              {o.status !== "pending_payment" && o.status !== "cancelled" ? (
                <div className="flex gap-2 mt-3 flex-wrap">
                  {STATUSES.map((s) => <button key={s} data-testid={`order-${o.id}-${s}`} onClick={() => update.mutate({ id: o.id, status: s })} disabled={o.status === s} className={`h-8 px-3 rounded-pill border font-body font-semibold text-xs ${o.status === s ? "bg-brand border-brand text-white" : "border-line text-ink"}`}>{s}</button>)}
                </div>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
